import { GridRowClassNameParams } from '@mui/x-data-grid';

export const homeURL = 'https://onthemove-35981.web.app'; // no trailing slash

/**
 * Opt-in zebra striping for any DataGrid: `getRowClassName={alternatingRowClassName}`. Colors and
 * hover live in the DataGrid theme override (src/themes/overrides/DataGrid.ts).
 */
export const alternatingRowClassName = (params: GridRowClassNameParams) =>
  params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd';

/**
 * Compose the striping class with a grid's own row classes. Use this when a grid needs a custom
 * `getRowClassName` (which would otherwise override the global default), e.g.
 * `getRowClassName={(p) => withAlternatingRow(p, p.row.finalized && 'row-finalized')}`.
 */
export const withAlternatingRow = (
  params: GridRowClassNameParams,
  ...extra: (string | false | null | undefined)[]
) => [alternatingRowClassName(params), ...extra.filter(Boolean)].join(' ');

export const saveDisabledURLs = ['/', '/contacts', '/event/services', '/event/talent', '/venues'];

export const gridW = { xs: 60, sm: 100, md: 140, lg: 200, xl: 300 };

export const rowHeight = 32;
export const headerHeight = 132;

export const timeOptionShort: Intl.DateTimeFormatOptions = {
  hour: '2-digit',
  minute: '2-digit',
  hour12: true
};

export default saveDisabledURLs;
